module.exports = __webpack_public_path__ + "static/media/8.21db2858.JPG";